export const FILTER_BY_ALPH = 'FILTER_BY_ALPH';
export const FILTER_BY_POPULATION = 'FILTER_BY_POPULATION';
export const FILTER_BY_CONTINENT = 'FILTER_BY_CONTINENT';
export const FILTER_BY_SEARCH = 'FILTER_BY_SEARCH';
export const FILTER_BY_ACTIVITY = 'FILTER_BY_ACTIVITY';
export const FIND_COUNTRY = 'FIND_COUNTRY';
export const GET_POST = 'GET_POST';
export const NEXT_PAGE = 'NEXT_PAGE';
export const PREV_PAGE = 'PREV_PAGE';
export const RESET = 'RESET';
export const LAST = 'LAST';